import React from 'react';
import vegas from '../../assets/images/vegas.jpg';
import './coverBackground.css'
import { useTranslation } from 'react-i18next';
import '../../i18n'

const CoverBackground = () => {
  const { t } = useTranslation();
  return (
    <div>
      {/* <div className="support-container"> */}
        {/* Image container with full width and 50% height */}
        <div className="image-container">
          <img src={vegas} alt="support" className="support-image" />
          {/* Centered support text */}
          <div className="support-text">
            <h3> {t('navigation:allServicesTitle')}</h3>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
}
export default CoverBackground;
